import React from 'react';
import { 
  Archive, 
  Unarchive 
} from '@mui/icons-material';

import BaseButton from './BaseButton';

interface Props extends React.ComponentPropsWithoutRef<'div'> {
  disabled?: boolean;
  label?: string;
  label_separate?: boolean;
  no_fab?: boolean;
  fab?: boolean;
  link_url?: string;
  is_archived?: boolean;
  log_it?: boolean;
  onClick: (event: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement> | undefined) => void;
  onMouseDown?: (event: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement>) => void;
}

export default function ArchiveButton(props: Props) {
  const pass_along_props = {...props};
  const is_archived = props.is_archived;
  delete pass_along_props.is_archived;

  const icon = is_archived ? <Unarchive/> : <Archive/>;

  return (
    <BaseButton
      icon={icon}
      {...pass_along_props}
    />
  );
}
